import { queryOptions } from "@tanstack/react-query";
import { type Api, getInvoicingIntegration } from "api-client";

export type InvoicingIntegration =
  Api.GetInvoicingIntegration.Output.Integration;
export type InvoicingProvider = Api.GetInvoicingIntegration.Output.Provider;

export const invoicingIntegrationKeys = {
  all: ["invoicing-integration"] as const,
};

export function invoicingIntegrationQueryOptions() {
  return queryOptions({
    queryKey: invoicingIntegrationKeys.all,
    queryFn: async () => {
      const response = await getInvoicingIntegration();
      return response.data.data;
    },
  });
}
